import lozad from 'lozad'
import {header} from '../index/scripts/header'
import {ToggleItem, detectCloseElement} from '../index/scripts/helper'
$(document).ready(function () {
	header.init()
	ToggleItem()
	makeIds()
	generateToc()
	handleTocFixed()
})
/*==================== TOC  ====================*/
function makeIds() {
	// eslint-disable-line
	var content = document.querySelector('#main-content')
	var headings = content.querySelectorAll('h1, h2, h3, h4, h5, h6, h7')
	var headingMap = {}

	Array.prototype.forEach.call(headings, function (heading) {
		var id = heading.id
			? heading.id
			: heading.textContent
					.trim()
					.toLowerCase()
					.replace(/\s+/g, '-')
					.replace(/[^a-z0-9-]/g, '')
		headingMap[id] = !isNaN(headingMap[id]) ? ++headingMap[id] : 0
		if (headingMap[id]) {
			heading.id = id + '-' + headingMap[id]
		} else {
			heading.id = id
		}
	})
	$("body").on("click", ".toc .title", function () {
		$(this).toggleClass('active');
		$(this).closest('.toc').find('.js-toc').slideToggle();
	});
}

function generateToc() {
	tocbot.init({
		tocSelector: '.js-toc',
		contentSelector: '.js-toc-content',
		headingSelector: 'h1, h2, h3,h4,h5',
		scrollSmooth: true,
		activeLinkClass: 'is-active-link',
		scrollSmoothOffset: -90,
		scrollSmoothDuration: 420,
		headingsOffset: 90,
		orderedList: false,
	})
	tocbot.init({
		tocSelector: '.js-toc-fixed',
		activeLinkClass: 'is-active-link',
		contentSelector: '.js-toc-content',
		headingSelector: 'h1, h2, h3,h4,h5',
		scrollSmooth: true,
		headingsOffset: 90,
		scrollSmoothOffset: -90,
		scrollSmoothDuration: 420,
		orderedList: true,
	})
}

function handleTocFixed() {
	$('.toc-button').on('click', function () {
		$('.wrap-toc-fixed').toggleClass('active')
	})
	//
	detectCloseElement('.wrap-toc-fixed', 'toc-button', () => {
		$('.wrap-toc-fixed').removeClass('active')
	})
	if (window.matchMedia('(max-width: 767.98px)').matches) {
		$('.wrap-toc-fixed a').on('click', function () {
			$('.wrap-toc-fixed').removeClass('active')
		})
	}
	//
	document.addEventListener(
		'scroll',
		function (e) {
			if ($(window).scrollTop() > 250) {
				$('.wrap-toc-fixed').addClass('show')
			} else {
				$('.wrap-toc-fixed').removeClass('show')
			}
		},
		true
	)
}
/*==================== Lazyload JS ====================*/
const observer = lozad() // lazy loads elements with default selector as '.lozad'
observer.observe()
